export enum JobStatus {
  IDLE = 'idle',
  QUEUED = 'queued',
  RUNNING = 'running',
  FINISHED = 'finished',
  FAILED = 'failed',
  CANCELED = 'canceled',
  EXPIRED = 'expired',
}
